module.exports = __webpack_public_path__ + "img/product_bg_new_03.9fc5e39.png";